/** Book-now → geri (bfcache) akışında tam sayfa yenilemesi işareti */
export const BFCACHE_HARD_REFRESH_KEY = "alsero-bfcache-hard-refresh";

/** Dil prefix’li ürün detay URL’leri (tur / yat) */
const PRODUCT_DETAIL_PATH =
  /^\/(?:[a-z]{2}\/)?(?:private-tours|group-tours|yacht)\/[^/]+\/?$/i;

export function markBfcacheHardRefreshOnNextRestore(): void {
  if (typeof window === "undefined") return;
  try {
    sessionStorage.setItem(BFCACHE_HARD_REFRESH_KEY, "1");
  } catch {
    // private mode / quota
  }
}

export function shouldHardRefreshAfterBfcacheRestore(): boolean {
  if (typeof window === "undefined") return false;
  try {
    if (sessionStorage.getItem(BFCACHE_HARD_REFRESH_KEY) === "1") {
      sessionStorage.removeItem(BFCACHE_HARD_REFRESH_KEY);
      return true;
    }
  } catch {
    // ignore
  }
  const path = window.location.pathname.replace(/\/$/, "") || "/";
  return PRODUCT_DETAIL_PATH.test(path);
}
